import { Component, OnInit } from '@angular/core';
import { ContactsList } from '../../models/notification.model';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {


  displayedColumns=[
    'number',
    'name',
    'email',
    'action',
  ]

  pageSizeOptions:number[] = [
    20,
    50,
    100,
    200,
    500
  ];
  pageSize:number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;

  contactsList:ContactsList

  constructor(
    private notificationService : NotificationService
  ) { }

  ngOnInit(): void {
    this.getNotificationContactsList()
  }

  getNotificationContactsList(reset:boolean=false){
    if(reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset , ordering:'-id'};
    this.notificationService.getNotificationContactsList(filters).subscribe(res=>{
      this.contactsList=res;
    })
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getNotificationContactsList()
  }

}
